<section class="lg:flex lg:items-center md:sm:grid md:sm:grid-cols-1 gap-4">
    <article class="lg:flex rounded h-10">
      <app-input-search [placeholder]="placeholder" [searchValue]="searchValue" (submitEventEmitter)="search($event)"></app-input-search>
    </article>
    <article class="relative lg:flex rounded" (click)="filterOpened = !filterOpened">
      <button id="buttonOpenFilter" 
        class="text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
        [ngClass]="{ 'opened' : filterOpened, 'filtersApplied': filtersApplied > 0 }">
        <img [src]="images.filter" alt="filter" class="w-6 h-6 mr-2" [ngClass]="{ 'filterOpened': filterOpened || filtersApplied > 0 }" />
        <span class="font-semibold text-base">{{ literalService.get("bookings.filter", true) }}</span>
      </button>
      @if (filtersApplied > 0) {
        <div class="w-4 h-4 absolute -top-2 -right-2 flex justify-center items-center p-2.5 text-xs font-bold text-white rounded-full filterBubble">
          {{ filtersApplied }}
        </div>
      }
    </article>
    <article class="flex absolute self-start mt-15 w-auto z-10 bg-white" [ngClass]="{ 'hidden': !filterOpened }">
      <app-booking-filter (filter)="filter.emit($event); updateFilters()" (closeFilter)="filterOpened = false; updateFilters()" [componentOpen]="'buttonOpenFilter'" [isFilterOpen]="filterOpened"></app-booking-filter>
    </article>
    <article class="relative lg:flex rounded">
      <button id="buttonRowsDisplayOpen" 
        class="text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
        [ngClass]="{ 'opened' : rowsDisplayOpened, 'filtersApplied': rowsDisplayValue !== defaultRowsDisplay }" (click)="rowsDisplayOpened = !rowsDisplayOpened">
        <img [src]="images.visibility" alt="filter" class="w-6 h-6 mr-2" [ngClass]="{ 'filterOpened': rowsDisplayOpened || rowsDisplayValue !== defaultRowsDisplay }" />
        <span class="font-semibold text-base">{{ `${literalService.get("bookings.show", true)}: ${rowsDisplayValue}` }}</span>
      </button>
      <article class="flex absolute mt-15 w-auto z-10 bg-white" [ngClass]="{ 'hidden': !rowsDisplayOpened }">
        <app-rows-display [componentOpen]="'buttonRowsDisplayOpen'" [value]="rowsDisplayValue" (close)="rowsDisplayOpened = false" (onChange)="updateNumberOfElements($event)"></app-rows-display>
      </article>
    </article>
    @if (searching) {
      <article class="flex items-center pb-2">
        <img [src]="images.loading" alt="loading" class="h-10 w-10 ml-4" />
        <label class="font-semibold text-base ml-4">{{ literalService.get('bookings.searchingBookings', true) }}...</label>
      </article>
    }
    <!-- <article id="sort" class="lg:flex lg:mr-4 rounded mb-2" (click)="sortedOpened = !sortedOpened">
      <button id="buttonOpenSort" 
        class="text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
      >
        <img [src]="images.sort" alt="sort" class="w-6 h-6 mr-2" />
        <span class="font-semibold text-base">{{
          literalService.get("users.sort", true)
        }}</span>
      </button>
    </article> -->
    <!-- <article id="sortModal" class="flex absolute mt-15 w-auto z-10 bg-white" [ngClass]="{ 'hidden': !sortedOpened }">
      <app-sort (closeSort)="sortedOpened = false" (sort)="sort.emit()" [componentOpen]="'buttonOpenSort'"></app-sort>
    </article> -->
    <!-- <article class="lg:flex lg:mr-4 rounded mb-2">
      <button class="text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center">
        <img [src]="images.visibilityOff" alt="visibilityOff" class="w-6 h-6 mr-2"/>
        <span class="font-normal">{{ literalService.get("users.manageColumns", true) }}</span>
      </button>
    </article>
    <article class="lg:flex lg:mr-4 rounded mb-2 inline-flex items-center">
      <img [src]="images.download" alt="download" class="w-8 h-8 mr-2" />
    </article> -->
    <!-- TODO: Uncomment this when we use me/permissions  -->
    <!-- @if (adminRole !== 'DRIVER_MANAGER' && roleService.permissions['RESERVATION']['CREATE']) { -->
    @if (adminRole !== 'DRIVER_MANAGER') {
      <section class="flex ml-auto gap-4 items-center">
        @if (allowBulkEditing) {
          <article class="flex flex-row gap-4 items-center">
            @for (action of bulkActions; track $index) {
              @if ((bulkSelectedAction !== '' && bulkSelectedAction === action.action) || (bulkSelectedAction === '') ) {
                @if (showActionButton(action.action)) {
                  <article class="px-4 py-1 rounded-[44px] cursor-pointer filledButton" (click)="onBulkAction.emit()">
                    {{ literalService.get(action.label, true) }}
                  </article>
                }
                <article class="w-10 h-10 flex justify-center items-center rounded-full outlinedButton" [ngClass]="{ 'primary-purple-light-2-background selected': bulkSelectedAction === action.action, 'cursor-pointer': bulkSelectedAction === '' }" (click)="onActionChange(action.action)" [tooltip]="literalService.get(action.label, true)" [visibleTooltip]="bulkSelectedAction === ''">
                  <img [src]="action.image" [alt]="action.action" class="w-6 h-6" [ngClass]="{ 'selected': bulkSelectedAction === action.action }" />
                </article>
              }
            } 
          </article>
        }
        @if (bulkSelectedAction === '') {
          <a
            class="lg:flex w-full rounded-[30px] px-3 py-1.5 inline-flex gap-1 justify-center items-center ml-auto cursor-pointer outlinedButton"
            (click)="addBookingEventEmitter.emit()"
            href="{{ `/bookings/new` }}"
            (click)="$event.preventDefault()"
          >
            <img [src]="images.booking.addBooking" alt="addBooking" class="w-5.5 h-5.5" />
            <span class="font-semibold text-base"> {{ literalService.get('bookings.newBooking', true) }} </span>
          </a>
        }
        @else {
          <article class="w-10 h-10 flex justify-center items-center rounded-full cursor-pointer outlinedButton" (click)="onActionChange('')">
            <img [src]="images.close" alt="cancelBulk" class="w-6 h-6" />
          </article>
        }
      </section>
    }
  </section>
  